@if (rateList.length) {
  <p-multiselect
    [selectAll]="null"
    [filter]="true"
    [options]="rateList"
    [disabled]="disabled()"
    [ngModel]="rates"
    (ngModelChange)="rates = $event; onRateChange($event)"
    maxSelectedLabels="1"
    placeholder="ALL"
    selectedItemsLabel="{0} selected"
    appendTo="body"
    dataKey="id"
  >
  </p-multiselect>
}
